import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import { translations } from './translations'
import get from 'lodash/get'
// UI
import styles from './main.scss'
import { setPreferences, getPreferences } from '../../../globals/tracking/preferences'

export const MediaOverlay = ({ onAccept, data }) => {
  const language = get(data, 'campaignData.cookieOverlay.language', 'de')

  const handleAccept = () => {
    if (onAccept) onAccept()
    const campaignId = get(data, 'campaignData._id')
    const cookies = getPreferences(campaignId)
    const updatedCookies = Object.assign({}, cookies)
    updatedCookies.Media = true

    setPreferences(campaignId, updatedCookies)
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <svg width="100%" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d)">
                <circle cx="17" cy="16" r="15" fill="black" fill-opacity="0.1" stroke="white" stroke-width="2" />
                <path
                  d="M14.5 19.1925V12.1155C14.5 11.271 15.4821 10.8068 16.1347 11.3428L20.5382 14.9599C21.0321 15.3656 21.0238 16.1241 20.5213 16.519L16.1178 19.9789C15.4617 20.4944 14.5 20.027 14.5 19.1925Z"
                  fill="white"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="0"
                  y="0"
                  width="34"
                  height="34"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="1" />
                  <feGaussianBlur stdDeviation="0.5" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
              </defs>
            </svg>
          </div>
          {translations[language].cta()}
          <div className={styles.button} onClick={handleAccept}>
            {translations[language].button}
          </div>
        </div>
      </div>
    </div>
  )
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          _id
          cookieOverlay {
            language
          }
        }
      }
    `}
    render={(data) => <MediaOverlay data={data} {...props} />}
  />
)
